// extracted by css-extract-rspack-plugin
export default {"choiceList":"choiceList-Jr1EIe","choice":"choice-xTscVf"};